import React from 'react';
import { Flex, InputNumber } from 'antd';

import { Duration } from '@totem/components/ticketing/ticketing';
import { isNotNull } from '@totem/utilities/common';

type Props = {
  value: Duration;
  onChange: (update: Duration) => void;
};

const DurationInput = ({ value, onChange }: Props) => {
  return (
    <Flex justify="flex-start" gap={'middle'}>
      <div>
        Days{' '}
        <InputNumber
          min={0}
          precision={0}
          value={isNotNull(value) ? value.days : 0}
          onChange={(val) => onChange({ ...value, days: val })}
        />
      </div>
      <div>
        Hours
        <InputNumber
          min={0}
          precision={0}
          value={isNotNull(value) ? value.hours : 0}
          onChange={(val) => onChange({ ...value, hours: val })}
        />
      </div>
      <div>
        Minutes
        <InputNumber
          min={0}
          precision={0}
          value={isNotNull(value) ? value.minutes : 0}
          onChange={(val) => onChange({ ...value, minutes: val })}
        />
      </div>
    </Flex>
  );
};

export default DurationInput;
